module.exports = __webpack_public_path__ + "static/media/1 0 Orddiktat Intro.ab10364c.mp3";